import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getBalance: () => ({
    url: 'Card/api/v1/User/Balance',
    method: 'GET',
  }),
  getCardDetail: () => ({
    url: 'Card/api/v1/user/Me',
    method: 'GET',
    rejectInterceptor: async (error) => {
      if (error.code === 'UserNotFound') {
        return { status: 'Initial' } as ISchemas['getCardDetail']['output'];
      }
      return Promise.reject(error);
    },
  }),
  getTransactionsHistory: (input) => ({
    url: 'Card/api/v1/User/Last10Transactions',
    method: 'GET',
    params: input,
  }),
  submitWithdraw: (input) => ({
    url: 'Card/api/v1/User/Transfer/Withdraw',
    method: 'POST',
    data: input,
  }),
  submitDeposit: (input) => ({
    url: 'Card/api/v1/User/Transfer/Deposit',
    method: 'POST',
    data: input,
  }),
  getContract: () => ({
    url: 'Card/api/v1/User/Contract',
    method: 'GET',
  }),
  signContract: () => ({
    url: 'Card/api/v1/User/Contract',
    method: 'POST',
  }),
  registerUser: (input) => ({
    url: 'Card/api/v1/User/register',
    method: 'POST',
    data: input,
  }),
  sendRegisterOTP: () => ({
    url: 'Card/api/v1/User/Resend/Otp',
    method: 'POST',
  }),
  sendAccessWithdrawOTP: () => ({
    url: 'Card/api/v1/User/Access/withdraw/Otp',
    method: 'POST',
  }),
  sendActivateCardOTP: (input) => ({
    url: 'Card/api/v1/User/ActiveCard',
    method: 'POST',
    data: input,
  }),
  sendRestoreOTP: () => ({
    url: 'Card/api/v1/User/Resend/Otp',
    method: 'POST',
  }),
  verifyRegisterOTP: (input) => ({
    url: 'Card/api/v1/User/Verify/Otp',
    method: 'POST',
    data: input,
  }),
  verifyAccessWithdrawOTP: (input) => ({
    url: 'Card/api/v1/User/Access/withdraw/Otp/Verify',
    method: 'POST',
    data: input,
  }),
  verifyActivateCardOTP: (input) => ({
    url: 'Card/api/v1/User/ActiveCard/Verify',
    method: 'POST',
    data: input,
  }),
  verifyRestoreOTP: (input) => ({
    url: 'Card/api/v1/User/ReVerify/Otp',
    method: 'POST',
    data: input,
  }),
  getUserAddress: () => ({
    url: 'Card/api/v1/User/Address',
    method: 'GET',
  }),
  getAddressByPostalCode: (input) => ({
    url: `Card/api/v1/Baseinfo/AddressByPostalCode/${input.postalCode}`,
    method: 'GET',
  }),
  getProvinces: () => ({
    url: 'Card/api/v1/Baseinfo/Province',
    method: 'GET',
  }),
  getCities: (input) => ({
    url: `Card/api/v1/Baseinfo/City/${input.provinceCode}`,
    method: 'GET',
  }),
  submitAddress: (input) => ({
    url: 'Card/api/v1/User/Address',
    method: 'POST',
    data: input,
  }),
  payPrice: () => ({
    url: 'Card/api/v1/User/PayPrice',
    method: 'POST',
  }),
  recoverPassword: () => ({
    url: 'Card/api/v1/User/Password/Recovery',
    method: 'POST',
  }),
  activateWepodCard: (input) => ({
    url: 'Card/api/v1/User/ActiveCard/WePod',
    method: 'POST',
    data: input,
  }),
  getRegistrationVerification: () => ({
    url: 'Card/api/v1/User/Registration/Verification',
    method: 'GET',
  }),
};

export default apis;
